
export default function checkUserPermission(name){
    let status = false;
    try{
    let user = JSON.parse(localStorage.getItem('user'));
    var index = user.permissions.findIndex((obj => 
        // console.log(obj,name);
        obj == name));
    if(index!=-1){
        status = true;
        
    }
    return status;
}
catch(e){
    return false 
}
}





// export default 



// WEBPACK FOOTER //
// ./src/plugins/permissions.js